export default __webpack_public_path__ + "static/media/hallway-mid.4b8996cb.mp4";